import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4 9c0-1.655 1.345-3 3-3h18c1.655 0 3 1.345 3 3v15c0 1.655-1.345 3-3 3H7c-1.655 0-3-1.345-3-3zm2.25 12.75v1.5c0 .413.338.75.75.75h1.5c.412 0 .75-.337.75-.75v-1.5A.75.75 0 0 0 8.5 21H7a.75.75 0 0 0-.75.75M23.5 21a.75.75 0 0 0-.75.75v1.5c0 .413.337.75.75.75H25c.413 0 .75-.337.75-.75v-1.5A.75.75 0 0 0 25 21zM6.25 15.75v1.5c0 .413.338.75.75.75h1.5c.412 0 .75-.337.75-.75v-1.5A.75.75 0 0 0 8.5 15H7a.75.75 0 0 0-.75.75M23.5 15a.75.75 0 0 0-.75.75v1.5c0 .413.337.75.75.75H25c.413 0 .75-.337.75-.75v-1.5A.75.75 0 0 0 25 15zM6.25 9.75v1.5c0 .412.338.75.75.75h1.5c.412 0 .75-.338.75-.75v-1.5A.75.75 0 0 0 8.5 9H7a.75.75 0 0 0-.75.75M23.5 9a.75.75 0 0 0-.75.75v1.5c0 .412.337.75.75.75H25c.413 0 .75-.338.75-.75v-1.5A.75.75 0 0 0 25 9zm-12 1.5v3c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-6c-.83 0-1.5.67-1.5 1.5M13 18c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }